// URLs de la API - Sistema de Recursos Humanos
// Laragon: DocumentRoot = raíz del repo; Laravel vive en backend/public
const LOCAL_API_HOST = "http://ch-rrhh.test";
const LOCAL_API_PATH = "/backend/public/api/v1/";
const localApiUrl = LOCAL_API_HOST + LOCAL_API_PATH;
const productionApiUrl = import.meta.env.VITE_API_BASE_URL
    || "https://rrhhsaludapi.digitalsis.com.ar/api/v1/";

export function serverPath(){
    const hostname = window.location.hostname;
    
    // Vite dev (localhost:3000): ruta relativa proxied por vite.config.js → ch-rrhh.test
    if(hostname === "localhost" || hostname === "127.0.0.1") {
        return "/api/v1/";
    }
    
    // Dominio .test: mismo origen → ruta relativa al backend/public; otro origen → URL absoluta
    if(hostname.includes(".test")) {
        const currentOrigin = window.location.origin;
        if(currentOrigin !== `http://${hostname}` && currentOrigin !== `https://${hostname}`) {
            return localApiUrl;
        }
        return LOCAL_API_PATH;
    }
    
    // Producción: usar la URL configurada (cada proyecto debe definir productionApiUrl o su lógica)
    if(productionApiUrl) {
        return productionApiUrl;
    }
    
    return "/api/v1/";
}

// Función para detectar si un error es de token vencido
function isTokenExpiredError(errorMessage) {
    if (!errorMessage) return false;
    const errorLower = errorMessage.toLowerCase();
    return errorLower.includes('token vencido') || 
           errorLower.includes('token inválido') || 
           errorLower.includes('token invalido') ||
           errorLower.includes('token requerido') ||
           errorLower.includes('unauthorized');
}

// Función para desloguear al usuario cuando el token está vencido
function handleTokenExpired() {
    // Limpiar el localStorage
    const constantes = {
        usuario: "ch-plantilla-usuario"
    };
    window.localStorage.removeItem(constantes.usuario);
    
    // Redirigir al login si no estamos ya ahí
    // Usar hash para HashRouter
    const currentPath = window.location.hash || window.location.pathname;
    if (!currentPath.includes('/login')) {
        window.location.hash = '#/login';
    }
}

export async function postData(name = '', data = {}, token = null) {
    const response = { data: {}, error: "", warning: "", filename: "" };

    const headers = {
        'Content-Type': 'application/json',
        //'Content-Type': 'application/x-www-form-urlencoded',
    };

    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        /*mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client*/
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: headers,
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
        .then((res) => {
            var t_contentDisposition = res.headers.get("content-disposition");
            if(t_contentDisposition!=null && t_contentDisposition.includes("attachment")){
                response.filename = t_contentDisposition.split(";")[1].split('=')[1];
                return res.blob();
            }
            else{
                // Manejar respuestas sin contenido (204 No Content) antes de verificar res.ok
                if (res.status === 204) {
                    return null;
                }
                
                if (!res.ok) {
                    // Intentar parsear el error, pero manejar el caso de respuesta vacía
                    const contentType = res.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        return res.json().then(err => {
                            let errorMsg = 'Error en la petición';
                            
                            // Manejar errores de validación de Laravel (422)
                            if (res.status === 422) {
                                // Priorizar el mensaje principal si existe
                                if (err.message) {
                                    errorMsg = err.message;
                                } else if (err.error) {
                                    errorMsg = err.error;
                                } else if (err.errors) {
                                    // Formatear errores de validación de Laravel
                                    const validationErrors = Object.entries(err.errors)
                                        .map(([field, messages]) => {
                                            return Array.isArray(messages) ? messages.join(', ') : messages;
                                        })
                                        .join('. ');
                                    errorMsg = validationErrors || errorMsg;
                                }
                                
                                // Debug: verificar que el mensaje se está extrayendo correctamente
                                console.log('Error 422 detectado:', {
                                    errMessage: err.message,
                                    errError: err.error,
                                    errErrors: err.errors,
                                    errorMsgFinal: errorMsg
                                });
                            } else {
                                // Manejar otros tipos de errores
                                errorMsg = err.error?.message || err.error || err.message || errorMsg;
                            }
                            
                            // Verificar si es error de token vencido
                            if (isTokenExpiredError(errorMsg) || res.status === 401) {
                                handleTokenExpired();
                            }
                            
                            // Crear un error con el mensaje correcto
                            const error = new Error(errorMsg);
                            error.status = res.status;
                            throw error;
                        }).catch((parseError) => {
                            // Si hay un error al parsear JSON, pero ya tenemos un mensaje de error válido, usarlo
                            // Verificar si el error tiene un mensaje válido (no es un error de parseo JSON)
                            if (parseError.message && 
                                parseError.message !== 'Error en la petición' && 
                                !parseError.message.includes('JSON') &&
                                !parseError.message.includes('Unexpected token') &&
                                parseError.message !== `Error ${res.status}: ${res.statusText}`) {
                                // El error ya tiene un mensaje válido, propagarlo
                                throw parseError;
                            }
                            // Si llegamos aquí, es un error de parseo JSON real
                            if (res.status === 401) {
                                handleTokenExpired();
                            }
                            // Solo usar statusText como último recurso
                            const error = new Error(`Error ${res.status}: ${res.statusText}`);
                            error.status = res.status;
                            throw error;
                        });
                    } else {
                        if (res.status === 401) {
                            handleTokenExpired();
                        }
                        const error = new Error(`Error ${res.status}: ${res.statusText}`);
                        error.status = res.status;
                        throw error;
                    }
                }
                
                // Verificar si hay contenido antes de parsear JSON
                const contentType = res.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    return res.json();
                }
                return null;
            }
            
        })
        .then((data) => {
            response.data = data?.data ? data.data : (data ? data : []);
            response.error = data?.error ? data.error : "";
            response.warning = data?.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            
            // Debug: verificar qué mensaje se está recibiendo en postData
            if (error.status === 422) {
                console.log('Error 422 capturado en postData catch:', {
                    errorMessage: error.message,
                    errorStatus: error.status,
                    errorType: error.constructor.name,
                    errorStack: error.stack
                });
            }
            
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}

export async function getData(name = '', token = null) {
    const response = { data: {}, error: "", warning: "" };

    const headers = {
        'Content-Type': 'application/json',
    };

    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        method: 'GET',
        headers: headers,
    })
        .then((res) => {
            if (!res.ok) {
                return res.json().then(err => {
                    const errorMsg = err.error?.message || err.error || 'Error en la petición';
                    // Verificar si es error de token vencido
                    if (isTokenExpiredError(errorMsg) || res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(errorMsg);
                }).catch(() => {
                    if (res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(`Error ${res.status}: ${res.statusText}`);
                });
            }
            return res.json();
        })
        .then((data) => {
            response.data = data.data ? data.data : (data ? data : {});
            response.error = data.error ? data.error : "";
            response.warning = data.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}

export async function getDataFull(name = '', token = null) {
    const response = { data: {}, error: "", warning: "", meta: {} };

    const headers = {
        'Content-Type': 'application/json',
    };

    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        method: 'GET',
        headers: headers,
    })
        .then((res) => {
            if (!res.ok) {
                // Intentar parsear el error, pero manejar el caso de respuesta vacía
                const contentType = res.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    return res.json().then(err => {
                        let errorMsg = 'Error en la petición';
                        
                        // Manejar errores de validación de Laravel (422)
                        if (res.status === 422) {
                            // Priorizar el mensaje principal si existe
                            if (err.message) {
                                errorMsg = err.message;
                            } else if (err.error) {
                                errorMsg = err.error;
                            } else if (err.errors) {
                                // Formatear errores de validación de Laravel
                                const validationErrors = Object.entries(err.errors)
                                    .map(([field, messages]) => {
                                        return Array.isArray(messages) ? messages.join(', ') : messages;
                                    })
                                    .join('. ');
                                errorMsg = validationErrors || errorMsg;
                            }
                        } else {
                            // Manejar otros tipos de errores
                            errorMsg = err.error?.message || err.error || err.message || errorMsg;
                        }
                        
                        // Verificar si es error de token vencido
                        if (isTokenExpiredError(errorMsg) || res.status === 401) {
                            handleTokenExpired();
                        }
                        
                        // Crear un error con el mensaje correcto
                        const error = new Error(errorMsg);
                        error.status = res.status;
                        throw error;
                    }).catch((parseError) => {
                        // Si hay un error al parsear JSON, pero ya tenemos un mensaje de error válido, usarlo
                        if (parseError.message && 
                            parseError.message !== 'Error en la petición' && 
                            !parseError.message.includes('JSON') &&
                            !parseError.message.includes('Unexpected token') &&
                            parseError.message !== `Error ${res.status}: ${res.statusText}`) {
                            // El error ya tiene un mensaje válido, propagarlo
                            throw parseError;
                        }
                        // Si llegamos aquí, es un error de parseo JSON real
                        if (res.status === 401) {
                            handleTokenExpired();
                        }
                        // Solo usar statusText como último recurso
                        const error = new Error(`Error ${res.status}: ${res.statusText}`);
                        error.status = res.status;
                        throw error;
                    });
                } else {
                    if (res.status === 401) {
                        handleTokenExpired();
                    }
                    const error = new Error(`Error ${res.status}: ${res.statusText}`);
                    error.status = res.status;
                    throw error;
                }
            }
            
            // Verificar si hay contenido antes de parsear JSON
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return res.json();
            }
            return null;
        })
        .then((data) => {
            response.data = data.data ? data.data : (data ? data : {});
            response.meta = data.meta ? data.meta : {};
            response.error = data.error ? data.error : "";
            response.warning = data.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}

export async function putData(name = '', data = {}, token = null) {
    const response = { data: {}, error: "", warning: "" };

    const headers = {
        'Content-Type': 'application/json',
    };

    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(data)
    })
        .then((res) => {
            // Manejar respuestas sin contenido (204 No Content) antes de verificar res.ok
            if (res.status === 204) {
                return null;
            }
            
            if (!res.ok) {
                // Intentar parsear el error, pero manejar el caso de respuesta vacía
                const contentType = res.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    return res.json().then(err => {
                        const errorMsg = err.error?.message || err.error || 'Error en la petición';
                        // Verificar si es error de token vencido
                        if (isTokenExpiredError(errorMsg) || res.status === 401) {
                            handleTokenExpired();
                        }
                        throw new Error(errorMsg);
                    }).catch(() => {
                        if (res.status === 401) {
                            handleTokenExpired();
                        }
                        throw new Error(`Error ${res.status}: ${res.statusText}`);
                    });
                } else {
                    if (res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(`Error ${res.status}: ${res.statusText}`);
                }
            }
            
            // Verificar si hay contenido antes de parsear JSON
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return res.json();
            }
            return null;
        })
        .then((data) => {
            response.data = data?.data ? data.data : (data ? data : []);
            response.error = data?.error ? data.error : "";
            response.warning = data?.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}

export async function deleteData(name = '', token = null) {
    const response = { data: {}, error: "", warning: "" };

    const headers = {
        'Content-Type': 'application/json',
    };

    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        method: 'DELETE',
        headers: headers,
    })
        .then((res) => {
            // Manejar respuestas sin contenido (204 No Content) antes de verificar res.ok
            if (res.status === 204) {
                return null;
            }
            
            if (!res.ok) {
                // Intentar parsear el error, pero manejar el caso de respuesta vacía
                const contentType = res.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    return res.json().then(err => {
                        const errorMsg = err.error?.message || err.error || 'Error en la petición';
                        // Verificar si es error de token vencido
                        if (isTokenExpiredError(errorMsg) || res.status === 401) {
                            handleTokenExpired();
                        }
                        throw new Error(errorMsg);
                    }).catch(() => {
                        if (res.status === 401) {
                            handleTokenExpired();
                        }
                        throw new Error(`Error ${res.status}: ${res.statusText}`);
                    });
                } else {
                    if (res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(`Error ${res.status}: ${res.statusText}`);
                }
            }
            
            // Verificar si hay contenido antes de parsear JSON
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return res.json();
            }
            return null;
        })
        .then((data) => {
            response.data = data?.data ? data.data : (data ? data : {});
            response.error = data?.error ? data.error : "";
            response.warning = data?.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}

// GET para endpoints PUBLICOS (verificacion de credenciales QR).
// No envia token Bearer y NO redirige al login ante 401/errores:
// el ciudadano no tiene sesion y la pagina publica debe poder mostrar
// estados de credencial invalida/vencida/revocada sin desloguear a nadie.
export async function getPublicData(name = '') {
    const response = { data: null, error: "", warning: "" };

    const headers = {
        'Content-Type': 'application/json',
    };

    await fetch(serverPath() + name, {
        method: 'GET',
        headers: headers,
    })
        .then((res) => {
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return res.json();
            }
            return null;
        })
        .then((data) => {
            response.data = data?.data ? data.data : (data ? data : null);
            response.error = data?.error ? data.error : "";
            response.warning = data?.warning ? data.warning : "";
        })
        .catch((error) => {
            let t_error = error.message;
            if (t_error === "Failed to fetch") {
                t_error = "Error al conectar con el servidor";
            }
            response.error = t_error;
        });

    return response;
}

export async function postFiles(name = '', data = {}, files = {}, token = null) {
    const response = { data: {}, error: "", warning: "" };

    const keysData = Object.keys(data);
    const keysFiles = Object.keys(files);
    const formData = new FormData();
    
    for (var i = 0; i < keysData.length; i++) {
        formData.append(keysData[i], data[keysData[i]]);
    }
    for (i = 0; i < keysFiles.length; i++) {
        for (var i2 = 0; i2 < files[keysFiles[i]].length; i2++) {
            if (files[keysFiles[i]][i2].file !== null)
                formData.append(keysFiles[i] + "_" + i2, files[keysFiles[i]][i2].file);
        }
        formData.append(keysFiles[i], JSON.stringify(files[keysFiles[i]]));
    }

    const headers = {};
    // Agregar token de autenticación si está presente
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(serverPath() + name, {
        method: 'POST',
        headers: headers,
        body: formData
    })
        .then((res) => {
            if (!res.ok) {
                return res.json().then(err => {
                    const errorMsg = err.error?.message || err.error || 'Error en la petición';
                    // Verificar si es error de token vencido
                    if (isTokenExpiredError(errorMsg) || res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(errorMsg);
                }).catch(() => {
                    if (res.status === 401) {
                        handleTokenExpired();
                    }
                    throw new Error(`Error ${res.status}: ${res.statusText}`);
                });
            }
            return res.json();
        })
        .then((data) => {
            response.data = data.data ? data.data : [];
            response.error = data.error ? data.error : "";
            response.warning = data.warning ? data.warning : "";
        })
        .catch((error) => {
            var t_error = error.message;
            // Verificar si es error de token vencido
            if (isTokenExpiredError(t_error)) {
                handleTokenExpired();
                t_error = "Sesión expirada. Por favor, inicia sesión nuevamente.";
            } else {
                switch(t_error){
                    case "Failed to fetch":
                        t_error = "Error al conectar con el servidor";
                        break;
                    default:
                        // Mantener el mensaje de error original
                        break;
                }
            }
            response.error = t_error;
        });

    return response;
}
